import deferred from './utils/deferred'

export default {
  ready: deferred(),
}
